<template>
    <div>
      <el-dialog :title="title" :visible="carVisibleProp" width="80%" @close="onClose">
          <el-form label-width="100px" :inline="true" size="mini">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="基本信息" name="first">

                      <el-row :gutter="24">
                          <el-col :span="8">
                              <el-form-item label="车牌号" prop="plate_number">
                                  <el-input v-model="addFrom.plate_number"/>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="车主" prop="allPerson">
                                  <el-input v-model="addFrom.allPerson"/>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="备注" prop="car_number">
                                  <el-input v-model="car_number"/>
                              </el-form-item>
                          </el-col>

                      </el-row>

                      <el-row :gutter="24">
                          <el-col :span="8">
                              <el-form-item label="投保人姓名" prop="car_number">
                                  <el-input v-model="car_number"/>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="投保人身份证" prop="car_number">
                                  <el-input v-model="car_number"/>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="投保人电话" prop="car_number">
                                  <el-input v-model="car_number"/>
                              </el-form-item>
                          </el-col>

                      </el-row>
                      <el-row :gutter="24">
                          <el-col :span="8">
                              <el-form-item label="被投保人姓名" prop="car_number">
                                  <el-input v-model="car_number"/>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="被投保人身份证" prop="car_number">
                                  <el-input v-model="car_number"/>
                              </el-form-item>
                          </el-col>
                          <el-col :span="8">
                              <el-form-item label="被投保人电话" prop="car_number">
                                  <el-input v-model="car_number"/>
                              </el-form-item>
                          </el-col>

                      </el-row>
                      <el-row :gutter="24">
                          <el-col :span="24">
                              <div class="table_box">
                                  <div style="text-align: left;padding:10px 0;">
                                      <el-button type="primary" size="mini" @click="addItem">新增保险产品</el-button>
                                  </div>
                                  <el-table :data="list" border  size="mini" :summary-method="getSummaries" show-summary style="width: 100%;" stripe height="260">
                                      <el-table-column label="序号" width="80px" align='center'>
                                          <template slot-scope="scope">
                                              <span>{{ scope.$index +1 }}</span>
                                          </template>
                                      </el-table-column>
                                      <el-table-column prop="product_id" label="保险产品名称" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{scope.row.product_name}}</span>
                                              <el-select
                                                      size="mini"
                                                      v-if="scope.row.isEgdit"
                                                      v-model="product_id"
                                                      filterable
                                                      remote
                                                      reserve-keyword
                                                      placeholder="请输入关键词"
                                                      :remote-method="remoteMethod"
                                                      :loading="loading">
                                                     <el-option
                                                          v-for="item in options"
                                                          :key="item.value"
                                                          :label="item.label"
                                                          :value="item.value">
                                                    </el-option>
                                              </el-select>
                                          </template>
                                      </el-table-column>
                                      <el-table-column label="保司" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{['橙子','橘子','榴莲'][scope.row.fruitSort-1]}}</span>
                                              <el-select size="mini" placeholder="请选择" v-if="scope.row.isEgdit" v-model="scope.row.fruitSort">
                                                  <el-option v-for="(item, index) in ['橙子','橘子','榴莲']" :key="index+1" :label="item" :value="index+1">
                                                  </el-option>
                                              </el-select>
                                          </template>
                                      </el-table-column>
                                      <el-table-column prop="firstNum" label="保费" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{scope.row.firstNum}}</span>
                                              <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.firstNum"></el-input>
                                          </template>
                                      </el-table-column>
                                      <el-table-column prop="firstNum" label="净费" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{scope.row.firstNum}}</span>
                                              <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.firstNum"></el-input>
                                          </template>
                                      </el-table-column>
                                      <el-table-column prop="secondNum" label="投保日期" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{scope.row.secondNum}}</span>
                                              <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.secondNum"></el-input>
                                          </template>
                                      </el-table-column>
                                      <el-table-column prop="thirdNum" label="联系人" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{scope.row.thirdNum}}</span>
                                              <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.thirdNum"></el-input>
                                          </template>
                                      </el-table-column>
                                      <el-table-column prop="thirdNum" label="联系电话" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{scope.row.thirdNum}}</span>
                                              <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.thirdNum"></el-input>
                                          </template>
                                      </el-table-column>
                                      <el-table-column prop="fourthNum" label="备注" align='center'>
                                          <template slot-scope="scope">
                                              <span v-if="!scope.row.isEgdit">{{scope.row.fourthNum}}</span>
                                              <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.fourthNum"></el-input>
                                          </template>
                                      </el-table-column>
                                      <el-table-column  label="操作" align='center'>
                                          <template slot-scope="scope">
                                              <el-button v-if="!scope.row.isEgdit"  type="primary" size="mini" @click='edit(scope.$index,scope.row)' icon="el-icon-edit" circle></el-button>
                                              <el-button v-if="scope.row.isEgdit" type="success" size="mini" @click='editSuccess(scope.$index,scope.row)' icon="el-icon-check" circle></el-button>
                                              <el-button @click.native.prevent="deleteItem(scope.$index, list)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                                          </template>
                                      </el-table-column>
                                  </el-table>
                              </div>
                          </el-col>
                      </el-row>
                  </el-tab-pane>
                  <el-tab-pane label="保单文件" name="second">

                      <el-row :gutter="24">
                          <el-col :span="24">
                              <div class="upload_group">
                                  <div class="upload_list">
                                      <el-upload
                                              class="upload-demo"
                                              drag
                                              action="#"
                                              :before-upload="handleBeforeUpload"
                                              :on-success="uploadSuccess"
                                              :auto-upload="false"
                                              :on-change="uploadFile"
                                              :file-list="fileList"
                                              list-type="picture"
                                              multiple
                                      >
                                          <i class="el-icon-upload"></i>
                                          <div class="el-upload__text">将保险单拖到此处，或<em>点击上传</em></div>
                                      </el-upload>
                                  </div>
                              </div>
                          </el-col>
                      </el-row>

                  </el-tab-pane>
              </el-tabs>



          <el-row :gutter="24">
              <el-col style="display:flex;flex-direction: row;justify-content: flex-end">
                  <el-form-item>
                  <el-button @click="close">取消</el-button>
                  <el-button type="primary" @click="save">保存</el-button>
                  </el-form-item>
              </el-col>
          </el-row>
          </el-form>

      </el-dialog>
    </div>
</template>
<script>
  export default {
     name:'eInsurance',
     props:['carVisibleProp'],
     data(){
       return {
           productId:[],
           options: [],
           carList: [],
           loading: false,
           states: []
       ,   addFrom:{
               plate_number:''
           },
           title:'保单新增',
           car_number:'鲁Q2222',
           fileList:[],
           activeName: 'first',
           insurance_date:'',
           pickerOptions: {
               shortcuts: [{
                   text: '今天',
                   onClick(picker) {
                       picker.$emit('pick', new Date());
                   }
               }, {
                   text: '昨天',
                   onClick(picker) {
                       const date = new Date();
                       date.setTime(date.getTime() - 3600 * 1000 * 24);
                       picker.$emit('pick', date);
                   }
               }, {
                   text: '一周前',
                   onClick(picker) {
                       const date = new Date();
                       date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                       picker.$emit('pick', date);
                   }
               }]
           },
           list: [],
       }
     },
      mounted() {
          this.carList = this.states.map(item => {
              return { value: `${item}`, label: `${item}` };
          });
      },
      methods:{
        chooseCar(index){

        },
          remoteMethod(query) {
              if (query !== '') {
                  this.loading = true;
                  setTimeout(() => {
                      this.loading = false;
                      this.options = this.carList.filter(item => {
                          return item.label.toLowerCase()
                              .indexOf(query.toLowerCase()) > -1;
                      });
                  }, 200);
              } else {
                  this.options = [];
              }
          },
        onClose(){
            this.$emit('close')
        },
        close(){
            this.$emit('close')
        },
        handleBeforeUpload(){

        },
        uploadSuccess(){

        },
        uploadFile(){

        },
        save(){
         this.$emit('eventCar',this.car_number,1111);
       },
        dealSpace(str){
            return str.replace(/&nbsp;/gi, " ");
        },
        //合计 表格每一列需要带上prop
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总数量';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += '(个)';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        //新增数据
        addItem() {
            let item = {
                id: null,
                product_name:'',
                product_id:'',
                fruitSort: null,
                firstNum: null,
                secondNum: null,
                thirdNum: null,
                fourthNum: null,
                isEgdit: true
            }
            this.list.push(item)
        },
        //删除数据
        deleteItem(index, list) {
            list.splice(index, 1);
        },
        //编辑数据
        edit(index, row) {
            this.$set(row, 'isEgdit', true)
        },
        //编辑成功
        editSuccess(index, row) {
            this.$set(row, 'isEgdit', false)
        },
    }
  }
</script>
<style lang="less" scoped>
    //https://www.yzktw.com.cn/post/1262748.html
    .upload_group {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

    .upload_list {
        width: 100px;
        margin-right: 1rem;

    }

    /deep/.el-upload-dragger .el-upload__text {
        font-size: 10px;
        color: #409EFF;
    }

    /deep/.el-icon-upload:before {
        width: 30px !important;
        height: 30px !important;
    }
    .upload_list:last-child {
        margin-right: 0;
    }

    /deep/.el-upload-dragger {
        width: 100%;
        height: auto;
        padding: 20px 0;
        border: 1px solid #999;
    }

    /deep/.el-upload {
        width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
        margin: 10px 0;
    }
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/common/eInsurance.vue